module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--reset"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('ui-auth', {
    attrs: {
      "success-copy": ("Reset instructions were sent to <strong>" + (_vm.model.email || "the email you provided") + "</strong>."),
      "title": "Forgotten Password",
      "copy": "Enter the address associated with your account. We’ll send you instructions on how to reset your password.",
      "slug": "reset"
    }
  }, [_c('span', {
    attrs: {
      "slot": "link"
    },
    slot: "link"
  }, [_vm._v("Remembered your password? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Log in")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1afe04fe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Reset.vue
// module id = 322
// module chunks = 0